import { bindingMode } from 'aurelia-binding';
import { customElement } from 'aurelia-templating';
import { bindable } from 'aurelia-typed-observable-plugin';
import { chartThemes } from '@dynamik/common';

@customElement('theme-selector')
export class ThemeSelector {
  constructor(private element: Element) { }

  chartThemes = chartThemes;

  @bindable
  label: string;

  @bindable({ defaultBindingMode: bindingMode.twoWay })
  theme: string;
  themeChanged() {
    this.element.dispatchEvent(new CustomEvent('change', { bubbles: true }));
  }

  @bindable.booleanAttr
  readonly: boolean;

  handleChange() {
    return true;
  }
}
